import { classNames } from "primereact/utils";
import styles from "./InventoryNomenclatureItem.module.scss";
import { IInventoryItemInputModel } from "../models/inventoryNomenclatureModels";
import { SkeletonItem } from "../../../../common/components/skeletons/SkeletonItem";
import { UnitOfMeasureShortLabels } from "../../../../common/labels";
import { UnitOfMeasure } from "../../../../common/enums";
import { getInventoryItemDisplayName } from "../../../../common/utilities/inventoryDisplayUtility";

interface IInventoryNomenclatureItemProps {
  className?: string;
  item?: IInventoryItemInputModel;
  isLoading: boolean;
  /** Extra actions rendered to the right of the item details. */
  extraActions?: React.ReactNode;
}

export const InventoryNomenclatureItem = ({
  className,
  item,
  isLoading,
  extraActions,
}: IInventoryNomenclatureItemProps) => {
  const currentQty = Number(item?.currentQuantity ?? 0);
  const lowStockThreshold = Number(item?.lowStockThreshold ?? 0);
  const isNegativeStock = !!item && currentQty < 0;
  const isLowStock = !!item && !isNegativeStock && currentQty <= lowStockThreshold;

  const unitShort = item?.unitOfMeasure !== undefined
    ? UnitOfMeasureShortLabels[item.unitOfMeasure as UnitOfMeasure]
    : "";

  const price = typeof item?.price === "number" ? item.price.toFixed(2) : "—";

  return (
    <div
      className={classNames(className, styles.item, {
        [styles.item_deleted]: item?.isDeleted,
      })}
    >
      <div className={styles.item_skeleton_wrapper}>
        <SkeletonItem
          isLoading={isLoading}
          value={
            <div className={styles.item_wrapper}>
              <div className={styles.item_main}>
                <div className={styles.item_main_name}>
                  {item ? getInventoryItemDisplayName(item.name, item.brand) : ""}
                  <span className={styles.item_main_name_id}>(ID: {item?.id})</span>
                  {!!item?.notesCount && item.notesCount > 0 && (
                    <span className={styles.item_main_name_notes} title="Има бележки">
                      📝 {item.notesCount}
                    </span>
                  )}
                </div>
                <div className={styles.item_main_details}>
                  <span
                    className={classNames(styles.item_main_details_qty, {
                      [styles.item_main_details_qty_negative]: isNegativeStock,
                      [styles.item_main_details_qty_low]: isLowStock,
                    })}
                  >
                    {currentQty} {unitShort}
                  </span>
                  <span className={styles.item_main_details_separator}>•</span>
                  <span className={styles.item_main_details_price}>{price} €</span>
                  {item?.sku && (
                    <>
                      <span className={styles.item_main_details_separator}>•</span>
                      <span className={styles.item_main_details_sku}>SKU: {item.sku}</span>
                    </>
                  )}
                </div>
              </div>
            </div>
          }
        />
      </div>
      <div className={styles.item_actions} onClick={(e) => e.stopPropagation()}>
        {extraActions}
      </div>
    </div>
  );
};
